import { render, staticRenderFns } from "./RoomsList.vue?vue&type=template&id=029d06ee&"
import script from "./RoomsList.vue?vue&type=script&lang=js&"
export * from "./RoomsList.vue?vue&type=script&lang=js&"
import style0 from "./RoomsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports